export default import.meta.ROLLDOWN_FILE_URL_HJaCYbwmD7KReIZj8tQ72A